import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Subscription} from "rxjs";
import { TaxReturnsResolver } from "../../tax-returns-resolver";
import { ITaxReturn } from '../model/i-tax-return';
import {RubixDocumentsService} from "./rubix-documents.service";
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';


@Component({
    selector: 'app-rubix-documents',
    templateUrl: './rubix-documents.component.html',
    styleUrls: ['./rubix-documents.component.scss'],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: { scope: 'tax-returns', alias: 'taxReturns' },
        }
    ],
    standalone: false
})
export class RubixDocumentsComponent implements OnInit {
  subscriptions: Subscription[] = [];
  folderType: string;
  folderLinksLoaded: boolean = false;
  rootFolder: string;
  tempFolder: string;
  finalFolder: string;
  pathSeparator: string;

  constructor(
    public rubixDocumentsService: RubixDocumentsService,
    private taxReturnsResolver: TaxReturnsResolver,
    private route: ActivatedRoute,
    ) { }

  ngOnInit() {
    this.subscriptions.push(this.taxReturnsResolver.getTaxReturnObs().subscribe((data: ITaxReturn) => {
      this.folderLinksLoaded = true;
      this.rootFolder = data?.docshareRootFolder;
      this.tempFolder = data?.docshareTempFolder;
      this.finalFolder = data?.docshareFinalFolder;
      this.refreshDocumentFolder();
    }));
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      this.folderType = params['folder'];
      this.refreshDocumentFolder();
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  private refreshDocumentFolder() {
    if (!this.folderType || !this.folderLinksLoaded) { return; }
    if (this.folderType === 'root') {
      if (this.rootFolder && this.rubixDocumentsService.rootFolderLink === this.rootFolder) { return; }
      this.rubixDocumentsService.getRootFolderByFolderLink(this.rootFolder);
    } else if (this.folderType === 'temp') {
      if (this.tempFolder && this.rubixDocumentsService.rootFolderLink === this.tempFolder) { return; }
      this.rubixDocumentsService.getRootFolderByFolderLink(this.tempFolder);
    } else if (this.folderType === 'final') {
      if (this.finalFolder && this.rubixDocumentsService.rootFolderLink === this.finalFolder) { return; }
      this.rubixDocumentsService.getRootFolderByFolderLink(this.finalFolder);
    }
  }

}
